<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="8">
                    <h1 class="headline font-weight-light mb-3">
                        VIEW ISSUE
                    </h1>
                </v-col>
                <v-col :cols="4" class="text-right">
                    <v-text-field
                        v-model="form_search_singlepart"
                        label="Search Singlepart / Enter"
                        single-line
                        solo
                        rounded
                        dense
                        @keyup.enter="func_search_sg()"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    v-if="team_name === 'INVENTORY'"
                    class="mar-t-20"
                >
                    <v-btn
                        color="primary"
                        dark
                        small
                        rounded
                        class="mr-1"
                        @click="get_dialogIssue()"
                    >
                        <v-icon small class="mr-1">mdi-plus</v-icon>
                        Multi Issue
                    </v-btn>
                    <v-btn
                        color="amber"
                        dark
                        small
                        rounded
                        @click="get_dialogReturn()"
                    >
                        <v-icon small class="mr-1">mdi-plus</v-icon>
                        Multi Return
                    </v-btn>
                </v-col>
            </v-row>

            <div class="mt-2">
                <v-row>
                    <v-col cols="11" sm="6" md="2">
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="dateRangeText"
                                    label="Date range"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dates"
                                range
                                @change="get_date()"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        cols="11"
                        sm="6"
                        md="3"
                        v-if="team_name === 'INVENTORY'"
                    >
                        <v-autocomplete
                            clearable
                            :items="data_project"
                            item-text="project_name"
                            item-value="project_id"
                            v-model="form.projects"
                            menu-props="auto"
                            label="Select Projects"
                            hide-details
                            @change="searchIssue()"
                        ></v-autocomplete>
                    </v-col>
                    <v-col
                        cols="11"
                        sm="6"
                        md="3"
                        v-if="team_name === 'INVENTORY'"
                    >
                        <v-autocomplete
                            clearable
                            :items="data_branch"
                            item-text="branch_name"
                            item-value="branch_id"
                            v-model="form.branch"
                            menu-props="auto"
                            label="Select Branch"
                            hide-details
                            @change="searchIssue()"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="11" sm="5" md="3">
                        <v-text-field
                            v-model="form.value"
                            label="Single / Serial"
                            prepend-inner-icon="mdi-magnify"
                            @keyup="searchIssue($event.target.value)"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="1" class="mt-4">
                        <v-btn
                            x-small
                            fab
                            class="mr-1"
                            @click="reset()"
                            v-if="
                                dateRangeText != '' ||
                                    form.branch != '' ||
                                    form.value != '' ||
                                    form.projects
                            "
                        >
                            <v-icon>mdi-rotate-left</v-icon></v-btn
                        >
                    </v-col>
                </v-row>
            </div>

            <v-card>
                <v-row>
                    <v-col cols="12" v-if="chk_search == true">
                        <v-progress-linear
                            indeterminate
                            color="cyan"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
                <div v-for="(row, index) in data_issue" :key="row.transfer_id">
                    <hr v-if="index != 0" />
                    <hr v-if="index != 0" />
                    <v-row justify="end" class="pa-3">
                        <!-- <v-col cols="4" class="text-right">xx</v-col> -->
                        <v-col cols="12" class="text-right">
                            <v-btn
                                rounded
                                small
                                @click="printReturm(index)"
                                color="blue-grey lighten-3"
                            >
                                <v-icon class="mr-1" dark small
                                    >mdi-printer</v-icon
                                >
                                Print Return</v-btn
                            >
                            <v-btn
                                rounded
                                small
                                @click="print(row.maincase_id, row.subcase)"
                                class="ml-1"
                                color="teal lighten-2"
                            >
                                <v-icon class="mr-1" dark small
                                    >mdi-printer</v-icon
                                >
                                Print Issue</v-btn
                            >
                        </v-col>
                    </v-row>
                    <v-row class="pa-3 mar-t-30">
                        <v-col cols="12"
                            ><b>Project Name : </b>{{ row.project_name }}</v-col
                        >
                        <v-col cols="12" sm="6">
                            <v-row class="ml-1">
                                <b>CaseId : </b>{{ row.case_id }}-{{
                                    row.subcase
                                }}
                                <ViewMore
                                    class="fix-flex-end-row ml-1"
                                    :maincaseid="row.maincase_id"
                                />
                            </v-row>
                        </v-col>

                        <v-col cols="12" sm="6"
                            ><b>Refer Case : </b>{{ row.case_refer }}</v-col
                        >
                        <v-col cols="12">
                            <b>Case Title : </b> {{ row.case_title }}
                        </v-col>
                        <v-col cols="12" sm="6"
                            ><b>Site Name : </b>{{ row.site_name }}</v-col
                        >
                        <v-col cols="12" sm="6"
                            ><b>Branch Name : </b
                            >{{
                                row.branch_name + " / " + row.engineer_name
                            }}</v-col
                        >
                        <v-col cols="12" sm="6"
                            ><b>Solution : </b>{{ row.solution }}</v-col
                        >

                        <v-col cols="12 pa-0 mb-5 mt-1">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center">
                                                Part No
                                            </th>

                                            <th class="text-center">
                                                Singlepart
                                            </th>
                                            <th class="text-center">Status</th>
                                            <th class="text-center">
                                                Ce Status
                                            </th>
                                            <th class="text-center">
                                                Issue
                                            </th>
                                            <th class="text-center">
                                                Issue SN
                                            </th>
                                            <th class="text-center">
                                                Receive
                                            </th>
                                            <th class="text-center">
                                                Receive Sn
                                            </th>
                                            <th class="text-center">Remark</th>
                                            <th class="text-center">
                                                Return Part
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in row.parts"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}.
                                            </td>
                                            <td class="text-center">
                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <span
                                                            class="cur-p"
                                                            color="primary"
                                                            dark
                                                            v-on="on"
                                                            >{{
                                                                item.part_name
                                                            }}</span
                                                        >
                                                    </template>
                                                    <span>{{
                                                        item.part_description
                                                    }}</span>
                                                </v-tooltip>
                                            </td>

                                            <td class="text-center">
                                                {{ item.singlepart }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.status }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.ce_status }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.issue_by_x }} <br />
                                                {{ item.issue_date_x }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.issue_sn }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.receive_by_x }} <br />
                                                {{ item.receive_date_x }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.receive_sn }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.remark }}
                                            </td>
                                            <td class="text-center">
                                                <v-btn
                                                    v-if="
                                                        item.ce_status == null
                                                    "
                                                    fab
                                                    dark
                                                    x-small
                                                    color="orange"
                                                    class="mr-1"
                                                    @click="
                                                        cancel_issue_part(
                                                            item.part_issue_id
                                                        )
                                                    "
                                                >
                                                    <v-icon
                                                        >mdi-server-remove</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    v-else
                                                    fab
                                                    dark
                                                    x-small
                                                    class="mr-1"
                                                    :color="
                                                        item.status != 'Return'
                                                            ? 'teal accent-3'
                                                            : 'indigo lighten-2'
                                                    "
                                                    @click="
                                                        return_part(
                                                            row.parts,
                                                            row.maincase_id
                                                        )
                                                    "
                                                >
                                                    <v-icon small>
                                                        mdi-near-me</v-icon
                                                    ></v-btn
                                                >
                                                <!-- @click="
                                                        return_part(
                                                            item.part_issue_id,
                                                            item.issue_sn,
                                                            row.maincase_id,
                                                            item.status,
                                                            item.sameitem_supplier_id,
                                                            item.customer_serial,
                                                            item.customer_symptom,
                                                            item.part_description
                                                        )
                                                    " -->
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>

                    <div :id="'printDiv' + index">
                        <div v-if="chk_print === true">
                            <v-row
                                v-for="(r, i) in row.parts"
                                :key="i"
                                class="ml-2"
                            >
                                <v-col cols="5" style="border-style: solid;">
                                    <v-row style="margin-bottom:8px;">
                                        <v-col cols="4"
                                            ><img
                                                src="../../assets/bardode/acacia.jpg"
                                                class="img-1"
                                                style="margin-top:5px;"
                                        /></v-col>
                                        <v-col cols="3">
                                            <barcode
                                                v-bind:value="r.singlepart"
                                                width="1"
                                                height="50"
                                                font-size="12"
                                            >
                                            </barcode>
                                        </v-col>
                                        <v-col cols="5">
                                            <qr-code
                                                :text="r.singlepart"
                                                size="70"
                                                style="float:right; margin-top:5px;"
                                            ></qr-code>
                                        </v-col>
                                        <v-col class="mar-t-20" cols="12"
                                            ><b>Part Des.</b>
                                            {{ r.part_description }}</v-col
                                        >
                                        <v-col class="mar-t-20" cols="12"
                                            ><b>Project :</b>
                                            {{ row.project_name }}</v-col
                                        >
                                        <v-col class="mar-t-20" cols="12"
                                            ><b>CaseID :</b>
                                            {{ row.case_id }}</v-col
                                        >
                                        <v-col class="mar-t-20" cols="4"
                                            ><b>GOOD</b>
                                            <input
                                                class="ml-1"
                                                type="checkbox"
                                            />
                                        </v-col>

                                        <v-col class="mar-t-20" cols="4"
                                            ><b>BAD</b>
                                            <input class="ml-1" type="checkbox"
                                        /></v-col>

                                        <v-col class="mar-t-20" cols="4"
                                            ><b>DOA</b>
                                            <input class="ml-1" type="checkbox"
                                        /></v-col>
                                        <v-col class="mar-t-20" cols="12"
                                            >remark...........................................................</v-col
                                        >
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div>
                            <v-btn class="mx-2" fab small @click="back()">
                                <v-icon dark>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn
                                class="mx-2"
                                fab
                                small
                                :color="btn_color(n)"
                                v-for="n in page_count"
                                :key="n"
                                @click="get_tranfer_page(page_num_show(n))"
                            >
                                {{ page_num_show(n) }}
                            </v-btn>

                            <v-btn class="mx-2" fab small @click="next()">
                                <v-icon dark>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>

        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">RETURN PART</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <div
                            v-for="(row_part, index_part) in row_parts"
                            :key="index_part"
                        >
                            <v-chip>{{ index_part + 1 }}.</v-chip>
                            <v-chip color="amber" class="ml-1 mr-1">
                                {{ "Part : " + row_part.part_name }}</v-chip
                            >
                            <v-chip
                                color="teal accent-3"
                                v-if="row_part.singlepart != null"
                                >{{
                                    "Singlepart : " + row_part.singlepart
                                }}</v-chip
                            >
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-text-field
                                        label="Serial"
                                        v-model="row_part.sn_return"
                                        v-on:keyup.enter="chk_sn_return()"
                                        @change="chk_sn_return()"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete
                                        :items="items"
                                        v-model="row_part.return_status"
                                        label="เลือก"
                                        @change="
                                            func_status(
                                                row_part.return_status,
                                                row_part.maincase_id
                                            )
                                        "
                                    ></v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                    v-if="
                                        row_part.return_status === 'Same Item'
                                    "
                                >
                                    <v-autocomplete
                                        :items="supplier"
                                        item-text="supplier_name"
                                        item-value="supplier_id"
                                        v-model="row_part.supplier"
                                        label="Select Vendor"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row
                                v-if="row_part.return_status === 'Same Item'"
                            >
                                <v-col cols="12" sm="4">
                                    <v-text-field
                                        v-model="row_part.part_description"
                                        label="Model"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field
                                        v-model="row_part.serial"
                                        label="Serial"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field
                                        v-model="row_part.symptom"
                                        label="Symptom"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-textarea
                                        outlined
                                        label="Remark"
                                        v-model="row_part.remark"
                                        required
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-btn text @click="close">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success darken-1"
                        rounded
                        @click="save_return()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogIssue"
            :max-width="chk_multi_issue == 1 ? '550px' : '1000px'"
            persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">MULTI ISSUE</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" v-if="chk_multi_issue == 1">
                                <v-textarea
                                    outlined
                                    label="Multi issue..."
                                    required
                                    v-model="form_ml_issue"
                                ></v-textarea>
                            </v-col>
                            <v-col
                                cols="12"
                                v-if="chk_multi_issue == 2"
                                class="mar-t-10"
                            >
                                <v-chip
                                    :color="
                                        data_ml_issue.status == 'error'
                                            ? 'red accent-2'
                                            : 'teal accent-3'
                                    "
                                    >{{
                                        "Status : " + data_ml_issue.status
                                    }}</v-chip
                                >
                                <v-simple-table class="table-inv mt-2">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">#</th>
                                                <th class="text-center">
                                                    Part name
                                                </th>
                                                <th class="text-center">
                                                    Part description
                                                </th>
                                                <th class="text-center">
                                                    Project name
                                                </th>
                                                <th class="text-center">
                                                    Singlepart
                                                </th>
                                                <th class="text-center">
                                                    Remark
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(r,
                                                i) in data_ml_issue.data"
                                                :key="i"
                                            >
                                                <td class="text-center">
                                                    {{ i + 1 }}.
                                                </td>
                                                <td>
                                                    {{ r.part_name }}
                                                </td>
                                                <td>
                                                    {{ r.part_description }}
                                                </td>
                                                <td>
                                                    {{ r.project_name }}
                                                </td>
                                                <td>
                                                    {{ r.singlepart }}
                                                </td>
                                                <td>
                                                    {{ r.remark }}
                                                </td>
                                            </tr>
                                            <br />
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions class="mar-t-30">
                    <v-btn text @click="closeIssue()">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="chk_multi_issue == 1"
                        :disabled="form_ml_issue == ''"
                        color="success darken-1"
                        rounded
                        @click="save_multi_issue()"
                        >Save</v-btn
                    >
                    <v-btn
                        v-if="chk_multi_issue == 2"
                        :disabled="data_ml_issue.status == 'error'"
                        color="success darken-1"
                        rounded
                        @click="save_multi_issue()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogReturn"
            :max-width="chk_multi_return == 1 ? '550px' : '1000px'"
            persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">MULTI RETURN</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" v-if="chk_multi_return == 1">
                                <v-textarea
                                    v-model="form_ml_return"
                                    outlined
                                    label="Multi return..."
                                    required
                                ></v-textarea>
                            </v-col>
                            <v-col
                                cols="6"
                                md="10"
                                v-if="chk_multi_return == 2"
                            >
                                <v-chip
                                    :color="
                                        data_ml_return.status == 'error'
                                            ? 'red accent-2'
                                            : 'teal accent-3'
                                    "
                                    >{{
                                        "Status : " + data_ml_return.status
                                    }}</v-chip
                                >
                            </v-col>
                            <v-col
                                cols="6"
                                md="2"
                                v-if="
                                    chk_multi_return == 2 &&
                                        data_ml_return.status == 'ok'
                                "
                                class="text-right"
                            >
                                <v-checkbox
                                    v-model="checkbox"
                                    :label="`Scrap`"
                                ></v-checkbox>
                            </v-col>
                            <v-col
                                cols="12"
                                v-if="chk_multi_return == 2"
                                class="mar-t-30"
                            >
                                <v-simple-table class="table-inv mt-2">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">#</th>
                                                <th class="text-center">
                                                    Part name
                                                </th>
                                                <th class="text-center">
                                                    Part description
                                                </th>
                                                <th class="text-center">
                                                    Project name
                                                </th>
                                                <th class="text-center">
                                                    Singlepart
                                                </th>
                                                <th class="text-center">
                                                    Remark
                                                </th>
                                                <th
                                                    v-if="
                                                        data_ml_return.status ==
                                                            'ok'
                                                    "
                                                >
                                                    Status
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(r,
                                                i) in data_ml_return.data"
                                                :key="i"
                                            >
                                                <td class="text-center">
                                                    {{ i + 1 }}.
                                                </td>
                                                <td>
                                                    {{ r.part_name }}
                                                </td>
                                                <td>
                                                    {{ r.part_description }}
                                                </td>
                                                <td>
                                                    {{ r.project_name }}
                                                </td>
                                                <td>
                                                    {{ r.singlepart }}
                                                </td>
                                                <td>
                                                    {{ r.remark }}
                                                </td>
                                                <td
                                                    class="text-center"
                                                    v-if="
                                                        data_ml_return.status ==
                                                            'ok'
                                                    "
                                                >
                                                    <v-select
                                                        :items="[
                                                            'Good',
                                                            'DOA',
                                                            'Defective',
                                                        ]"
                                                        color="red"
                                                        v-model="r.ce_status"
                                                        menu-props="auto"
                                                        label="Select Status"
                                                        hide-details
                                                        @change="searchIssue()"
                                                    >
                                                        <template
                                                            #selection="{ item }"
                                                        >
                                                            <v-chip
                                                                :color="
                                                                    item ==
                                                                    'Good'
                                                                        ? 'teal accent-3'
                                                                        : 'red accent-2'
                                                                "
                                                                >{{
                                                                    item
                                                                }}</v-chip
                                                            >
                                                        </template>
                                                    </v-select>
                                                </td>
                                            </tr>
                                            <br />
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions class="mar-t-30">
                    <v-btn text @click="closeReturn()">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="chk_multi_return == 1"
                        :disabled="form_ml_return == ''"
                        color="success darken-1"
                        rounded
                        @click="save_multi_return()"
                        >Save</v-btn
                    >
                    <v-btn
                        v-if="chk_multi_return == 2"
                        :disabled="data_ml_return.status == 'error'"
                        color="success darken-1"
                        rounded
                        @click="save_multi_return()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import { mapState, mapMutations } from "vuex"
import VueBarcode from "vue-barcode"
import Qrcode from "v-qrcode/src/index"
import ViewMore from "./components/ViewMore"

const url = `${process.env.VUE_APP_ROOT_API}/api/issue`
const urls = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        barcode: VueBarcode,
        Qrcode,
        ViewMore,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        // this.get_data()
        this.get_search()
    },
    created() {
        this.searchIssue = _.debounce(this.searchIssue, 300)
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
        dateRangeText() {
            this.dates.sort((a, b) => {
                return new Date(a) - new Date(b)
            })
            return this.dates.join(" ~ ")
        },
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            let { data } = await axios.post(url, {}, this.tk)
            this.data_main = data
            this.data_issue = data.data
            this.page_total = data.last_page
            this.page_total < 7
                ? (this.page_count = this.page_total)
                : (this.page_count = 7)
        },
        async back() {
            let url = this.data_main.prev_page_url
            let { data } = await axios.post(url, {}, this.tk)
            this.data_issue = data.data
            this.data_main = data
        },
        async next() {
            let url = this.data_main.next_page_url
            let { data } = await axios.post(url, {}, this.tk)
            this.data_issue = data.data
            this.data_main = data
        },
        async get_tranfer_page(num) {
            this.current_page = num
            if (num != "...") {
                let url_page = url + "?page=" + num
                let { data } = await axios.post(url_page, {}, this.tk)
                this.data_issue = data.data
                this.data_main = data
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data_main.current_page <= 4) {
                    return this.data_main.current_page === n ? "primary" : ""
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_main.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_main.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_main.current_page - 1
                    chk4 = this.data_main.current_page
                    chk5 = this.data_main.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_main.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        async receive(transfer_id) {
            await axios
                .put(url + "/receive/" + transfer_id, {}, this.tk)
                .then((response) => {
                    this.get_data()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    this.chk_data = true
                })
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.searchIssue()
                this.menu2 = false
            }
        },
        async searchIssue() {
            let datasent = {
                branch: this.form.branch,
                date: this.dates,
                value: this.form.value,
                project_id: this.form.projects,
            }
            this.chk_search = true
            let { data } = await axios
                .post(url, datasent, this.tk)
                .then((response) => {
                    this.chk_search = false
                    this.data_main = response.data
                    this.data_issue = response.data.data
                    this.page_count = 1
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_search() {
            let { data } = await axios.get(
                `${process.env.VUE_APP_ROOT_API}/api/project-has-stock`,
                this.tk
            )
            this.data_project = data.projects
            this.data_branch = data.branchs
        },
        reset() {
            this.form.branch = ""
            this.dates = []
            this.form.value = ""
            this.form.projects = ""
            // this.get_data()
        },
        print(maincase_id, subcase) {
            let url_print =
                "/Inventory/Issue-Print/" + maincase_id + "/" + subcase
            // window.open(url_print)
            this.$router.push(url_print)
        },

        close() {
            // this.get_data()
            this.dialog = false
            this.show_serial = false
            this.form_return = {
                part_issue_id: "",
                return_status: "",
            }
        },
        // async return_part(
        //     part_issue_id,
        //     serials,
        //     maincase_id,
        //     status,
        //     sameitem_supplier_id,
        //     customer_serial,
        //     customer_symptom,
        //     part_description
        // ) {
        //     this.maincase_id = maincase_id
        //     this.form_return.part_description = part_description
        //     if (status === "Issued") {
        //         this.form_return.part_issue_id = part_issue_id
        //         this.serial = serials
        //     } else {
        //         let data = await axios.get(
        //             `${process.env.VUE_APP_ROOT_API}/api/data_sameitem/` +
        //                 maincase_id
        //         )

        //         this.form_return.part_issue_id = part_issue_id
        //         this.supplier = data.data.supplier
        //         this.form_return.sn_return = serials
        //         this.form_return.return_status = status
        //         this.form_return.supplier = sameitem_supplier_id
        //         this.form_return.serial = customer_serial
        //         this.form_return.symptom = customer_symptom
        //     }
        //     this.dialog = true
        // },
        return_part(parts, maincase_id) {
            this.row_parts = parts
            this.row_parts.map((each, index) => {
                if (each.return_status == "Same Item") {
                    axios
                        .get(
                            `${process.env.VUE_APP_ROOT_API}/api/data_sameitem/` +
                                maincase_id
                        )
                        .then((response) => {
                            this.supplier = response.data.supplier
                        })
                }
            })
            this.dialog = true
        },
        async save_return() {
            let url_return = `${process.env.VUE_APP_ROOT_API}/api/returnpart`
            let send = {
                parts: this.row_parts,
            }
            await axios
                .post(url_return, send, {
                    headers: { Authorization: "Bearer " + localStorage.token },
                })
                .then((response) => {
                    this.dialog = false
                    this.show_serial = false
                    // this.form_return = {
                    //     part_issue_id: "",
                    // }
                    this.get_data()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        chk_sn_return() {
            if (this.form_return.sn_return === this.serial) {
                this.form_return.return_status = "Good"
            } else {
                this.form_return.return_status = "Defective"
            }
        },
        async func_status(st, maincase_id) {
            if (st === "Same Item") {
                await axios
                    .get(
                        `${process.env.VUE_APP_ROOT_API}/api/data_sameitem/` +
                            maincase_id
                    )
                    .then((response) => {
                        let row_p = this.row_parts
                        this.row_parts.map((each, index) => {
                            row_p[index].serial = response.data.serial
                            row_p[index].symptom = response.data.symptom
                        })
                        this.supplier = response.data.supplier
                        this.row_parts = row_p
                    })
            }
        },
        printReturm(index) {
            this.mutateIsLoading()
            this.chk_print = true

            // const options = {
            //     name: "_blank",
            //     specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
            //     styles: [
            //         "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
            //         "https://unpkg.com/kidlat-css/css/kidlat.css",
            //     ],
            // }
            if (this.chk_print === true) {
                setTimeout(() => {
                    this.mutateIsLoading()
                    this.$htmlToPaper("printDiv" + index)
                }, 1000)
                setTimeout(() => {
                    this.chk_print = false
                }, 1100)
            }
        },
        cancel_issue_part(part_issue_id) {
            this.$swal({
                title: "ยกเลิกการ Issue Part นี้ ใช่ หรือ ไม่ ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    // this.mutateIsLoading()
                    axios
                        .get(
                            `${process.env.VUE_APP_ROOT_API}/api/issue-cancel/${part_issue_id}`,
                            this.tk
                        )
                        .then((response) => {
                            // this.mutateIsLoading()
                            this.get_data()
                            this.mutatesnackbar()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        get_dialogIssue() {
            this.chk_multi_issue = 1
            this.dialogIssue = true
        },
        async save_multi_issue() {
            let send = {
                textarea: this.form_ml_issue,
            }
            if (this.chk_multi_issue == 1) {
                await axios
                    .post(urls + "multi-issue/check", send, this.tk)
                    .then((response) => {
                        this.data_ml_issue = response.data
                        this.chk_multi_issue = 2
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else if (this.chk_multi_issue == 2) {
                await axios
                    .post(urls + "multi-issue/save", send, this.tk)
                    .then((response) => {
                        this.chk_multi_issue = 0
                        this.get_data()
                        this.closeIssue()
                        this.mutatesnackbar()
                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        closeIssue() {
            if (this.chk_multi_issue == 2) {
                this.chk_multi_issue = 1
            }
            this.form_ml_issue = ""
            this.dialogIssue = false
        },

        get_dialogReturn() {
            this.chk_multi_return = 1
            this.dialogReturn = true
        },
        async save_multi_return() {
            if (this.chk_multi_return == 1) {
                let send = {
                    textarea: this.form_ml_return,
                }
                await axios
                    .post(urls + "multi-return/check", send, this.tk)
                    .then((response) => {
                        this.data_ml_return = response.data
                        this.chk_multi_return = 2
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else if (this.chk_multi_return == 2) {
                let send2 = {
                    parts: this.data_ml_return.data,
                    scrap: this.checkbox,
                }
                await axios
                    .post(urls + "multi-return/save", send2, this.tk)
                    .then((response) => {
                        this.chk_multi_return = 0
                        this.closeReturn()
                        this.mutatesnackbar()
                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        closeReturn() {
            if (this.chk_multi_return == 2) {
                this.chk_multi_return = 1
            }
            this.form_ml_return = ""
            this.dialogReturn = false
        },
        async func_search_sg() {
            let routeData = this.$router.resolve({
                path: "/Search-Parts",
                query: { q: this.form_search_singlepart },
            })
            window.open(routeData.href, "_blank")
        },
    },
    data() {
        return {
            chk_search: false,
            data_issue: [],
            data_main: [],
            data_branch: [],
            data_project: [],
            page_count: 0,
            dates: [],
            supplier: [],
            text: "Success, Your work has been saved",
            chk_date: true,
            form: {
                branch: "",
                value: "",
                projects: "",
            },
            menu2: false,
            items: ["Good", "Bad", "DOA", "Install"],
            form_return: {
                part_issue_id: "",
                return_status: "",
                supplier: "",
                serial: "",
                symptom: "",
                part_description: "",
            },
            dialog: false,
            serial: "",
            maincase_id: "",
            team_name: localStorage.team_name,
            tk: "",
            chk_print: false,
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
            row_parts: [],
            //
            dialogIssue: false,
            chk_multi_issue: 0,
            dialogReturn: false,
            chk_multi_return: 0,
            form_ml_issue: "",
            form_ml_return: "",
            data_ml_issue: [],
            data_ml_return: [],
            checkbox: false,
            form_search_singlepart: "",
        }
    },
}
</script>
<style scoped>
.image-cso {
    height: 10;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
}
</style>
